/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_P1tInputs */

const en_mk_sol_lembaga_p1t = /** @type {(inputs: Mk_Sol_Lembaga_P1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowledge leaves when volunteers rotate`)
};

const id_mk_sol_lembaga_p1t = /** @type {(inputs: Mk_Sol_Lembaga_P1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengetahuan hilang saat relawan berganti`)
};

/**
* | output |
* | --- |
* | "Knowledge leaves when volunteers rotate" |
*
* @param {Mk_Sol_Lembaga_P1tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_p1t = /** @type {((inputs?: Mk_Sol_Lembaga_P1tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_P1tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_p1t(inputs)
	return en_mk_sol_lembaga_p1t(inputs)
});